import React from "react"
import { useTranslation } from "react-i18next"

const ShowMore = ({ onClick, showAll }) => {
  const { t } = useTranslation()

  const transKey = showAll ? "filter.hide" : "admin.show_more"

  return (
    <div className="flex justify-center mt-1">
      <button
        onClick={onClick}
        className=" text-second-success text-xs mt-2 hover:underline flex items-center cursor-pointer"
      >
        {t(transKey)}
      </button>
    </div>
  )
}

export default ShowMore
